import React, { useState, useEffect } from 'react';
import axios from 'axios';

// core components
import Navbar from "../layouts/Navbar.js";
import Footer from "../layouts/Footer.js";

import '../../assets/css/Board.css'

export default function Setting() {


  const [isLoading, setIsLoading] = useState(true);
  const [results, setResults] = useState([]);

  useEffect(() => {
    // 서버에서 게시글 데이터 가져오는 로직
    async function selectSettingList() {

      try {
        //로딩중 표기
        setIsLoading(true);

        const response = await axios.get(`/setting/selectSettingList`,
        { baseURL : process.env.REACT_APP_SERVER_URL },
        {
          withCredentials: true
        });

        const data = response.data;

        //console.log(data);

        //console.log("Posts Return : " + JSON.stringify(data.result));

        // 데이터를 성공적으로 가져왔으므로 로딩 상태를 false로 변경
        setIsLoading(false);

        setResults(data.results);

      } catch (error) {
        console.error('게시글 조회 오류:', error);
      }
    }

    selectSettingList();
  }, []);

  const updateSetting = async (e) => {
    e.preventDefault();

    let fields = [];

    for (var i = 0; i < results.length; i++){
      fields[i] = results[i].name;
    }

    //console.log("send fields value : " + JSON.stringify(fields));
    
    const formElements = e.target.elements;
    /*
    const formValues = fields
    .map((field) => ({
      [field]: formElements.namedItem(field).value
    }))
    .reduce((current, next) => ({ ...current, ...next }));
    */
   
    const formValues = fields
    .map((field) => ({
      name : field,
      value : formElements.namedItem(field).value
    }));

    //console.log(formValues);

    let registerRequest;

    try {
      registerRequest = await axios.post(
        `/setting/updateSetting`, {...formValues},
        { baseURL : process.env.REACT_APP_SERVER_URL,
        },{
          withCredentials: true
        });

        //console.log('환경설정 업데이트 성공');

        const { data: registerRequestData } = registerRequest;
        const messages = registerRequestData.messages;
        // 성공 메세지 표출
        if (messages && messages.success) {
          alert(messages.success);
        }

        window.location.reload();

    } catch ({ error }) {
      alert("환경설정 업데이트에 실패하였습니다. 잠시 후에 다시 시도해주세요.")
    }
  };

  const onEdit = (targetName, newValue) => {
    setResults(
      results.map((result) =>
        result.name === targetName ? {...result, value: newValue} : result)
    )
  }

  return (
    <>
    <Navbar/>
      <div className="wrapper">
        <div className="page-header">
          <div className="page-header-image" />

            <div id="ContactList" className="register-page">
            <div className="Section">
                <div className="cardWithTitle">
                <div className="SectionHeaderFull">
                    <div className="SectionHeaderTxtbox">
                    <div className="SectionHeaderCategory CategoryDark">Settings</div>
                    <div className="SectionHeaderTitle">환경설정</div>
                    </div>
                </div>

                <div className="SectionContents" style={{marginTop:'30px'}}>
                    {isLoading &&
                          // 로딩 중일 때 로딩 스피너 또는 메시지 표시
                        <div className="loader">
                          <div className="loader-container">
                            <p className='loader-title'>Loading...</p>
                          </div>
                        </div>
                    }
                    <div className="form-control">
                    <form onSubmit={updateSetting}>
                      {results && results.map((result, index) => {
                          return(
                            <div className="form-box">
                              <div className="form-label">{result.name}</div>
                              <input
                              type="text"
                              key={index} 
                              className="form-result"
                              id={result.id}
                              name={result.name}
                              value={result.value}
                              onChange={(e) => onEdit(result.name, e.target.value)}
                              />
                            </div>
                          )
                          })
                        }

                        <div className="form-button" style={{marginTop:'60px'}}>
                          <div className="board-view-modify-area">
                            <input className="form-button-sm" type="submit" value="수정"/>
                          </div>
                        </div>
                    </form>
                    </div>
                </div>
                </div>

            </div>
            </div>
          
        </div>
      </div>
    <Footer />
    </>
  );
}